import { apiClient } from "apiClient";
import { state } from "state";

import updateSize from "helpers/updateSize";
import type { TaskType } from "types";

export type FrostRange = {
  start_month: number;
  end_month: number;
  start_day: number;
  end_day: number;
};

export type CalendarEvent = {
  name: string;
  taskType: TaskType | "%future added value";
  resourceTitle: string;
};

const inFrostZone = (day: number, month: number, frost: FrostRange) => {
  if (frost.start_month < frost.end_month) {
    if (month > frost.start_month && month < frost.end_month) {
      return true;
    }
  }

  if (frost.start_month > frost.end_month) {
    if (month > frost.start_month || month < frost.end_month) {
      return true;
    }
  }

  if (frost.start_month == frost.end_month) {
    return day >= frost.start_day && day <= frost.end_day && month == frost.start_month;
  }

  if (month == frost.start_month && day >= frost.start_day) {
    return true;
  }

  return month == frost.end_month && day <= frost.end_day;
};

export const getFrostClass = (
  date: Date,
  averageFrost: FrostRange,
  hardFrost: FrostRange
) => {
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const isAverageFrost = inFrostZone(day, month, averageFrost);
  const isHardFrost = inFrostZone(day, month, hardFrost);

  if (isHardFrost) return "hard-frost";
  if (isAverageFrost) return "average-frost";
};

export const isFrostDay = (date: Date, averageFrost: FrostRange, hardFrost: FrostRange) =>
  getFrostClass(date, averageFrost, hardFrost) !== undefined;

export const updateCalendarSizeOnPrint = () => {
  const mql = window.matchMedia("print");

  mql.onchange = (e) => {
    if (e.matches) {
      setTimeout(updateSize, 200);
    }
  };
};

export const onYearMonthChange = (callback: EventListener) => {
  document.addEventListener("calendarYearMonthChanged", callback, false);
};

export const removeYearMonthChangeListener = (callback: EventListener) => {
  document.removeEventListener("calendarYearMonthChanged", callback);
};

export const triggerYearMonthChange = ({
  yearMonth,
  monthsNumber
}: {
  yearMonth?: string;
  monthsNumber?: number;
}) => {
  const event = new CustomEvent("calendarYearMonthChanged", {
    detail: { yearMonth, monthsNumber }
  });
  document.dispatchEvent(event);
};

export const eventTitle = (event: CalendarEvent) =>
  `${event.name} ${event.resourceTitle}`;

export const reloadCalendarViews = () => {
  state.markDirty();
  state.reloadAllCalendarViews();
};

export const refreshCalendar = () => {
  apiClient.plantings.fetchVisiblePlantings().then(({ visiblePlantings }) => {
    document.dispatchEvent(new CustomEvent("calendar:refresh"));
    state.setVisiblePlantings(visiblePlantings);
    reloadCalendarViews();
  });
};
